import { Box, IconButton, makeStyles, SvgIcon } from '@material-ui/core';
import { ReactComponent as DeleteIcon } from 'assets/icons/additional/red-trash.svg';
import { ReactComponent as EditIcon } from 'assets/icons/additional/image-edit-2.svg';
import React, { Fragment, useCallback } from 'react';
import AspectRatio from 'react-aspect-ratio';

const useStyles = makeStyles({
    container: {
        padding: 4,
        position: 'relative',
    },
    imageContainer: {
        borderRadius: 20,
        height: '100%',
        overflow: 'hidden',
        width: '100%',
    },
    image: {
        height: '100%',
        objectFit: 'cover',
        width: '100%',
    },
    editButton: {
        bottom: 8,
        padding: 0,
        position: 'absolute',
        right: 8,
        zIndex: 1,
    },
    deleteButton: {
        bottom: 8,
        padding: 0,
        position: 'absolute',
        left: 8,
        zIndex: 1,
    },
    icon: {
        borderRadius: 12,
        boxShadow: '1px 1px 8px rgba(0, 0, 0, 0.2)',
        height: 24,
        width: 24,
        '&:hover': {
            boxShadow: '1px 1px 8px rgba(0, 0, 0, 0.5)',
        },
    },
});

export interface GalleryImageProps {
    index: number;
    src: string;
    canEdit: boolean;
    previewRef: (ref: HTMLDivElement, index: number) => void;
    onEdit: (index: number) => void;
    onDelete: (index: number) => void;
    aspectRatio?: number;
}

export const GalleryImage = (props: GalleryImageProps) => {
    const { index, src, canEdit, previewRef, onEdit, onDelete, aspectRatio = 2 } = props;

    const classes = useStyles();

    const handleImageRef = useCallback((ref: HTMLDivElement) => previewRef(ref, index), [index, previewRef]);

    const handleEditClick = useCallback(() => {
        if (canEdit) {
            onEdit(index);
        }
    }, [index, onEdit, canEdit]);

    const handleDeleteClick = useCallback(() => onDelete(index), [index, onDelete]);

    return (
        <Box className={classes.container}>
            <AspectRatio ratio={aspectRatio}>
                <Fragment>
                    <div ref={handleImageRef} className={classes.imageContainer} onClick={handleEditClick}>
                        <img className={classes.image} src={src} alt="" />
                    </div>
                    <IconButton className={classes.deleteButton} onClick={handleDeleteClick}>
                        <SvgIcon className={classes.icon} component={DeleteIcon} viewBox="0 0 32 32" />
                    </IconButton>
                    {canEdit && <IconButton className={classes.editButton} onClick={handleEditClick}>
                        <SvgIcon className={classes.icon} component={EditIcon} viewBox="0 0 24 24" />
                    </IconButton>}
                </Fragment>
            </AspectRatio>
        </Box>
    );
};
